import { render, staticRenderFns } from "./BookingTermsAndConditionsModal.vue?vue&type=template&id=4ae6b1d6&scoped=true"
import script from "./BookingTermsAndConditionsModal.vue?vue&type=script&lang=js"
export * from "./BookingTermsAndConditionsModal.vue?vue&type=script&lang=js"
import style0 from "./BookingTermsAndConditionsModal.vue?vue&type=style&index=0&id=4ae6b1d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae6b1d6",
  null
  
)

export default component.exports